<template>
  <!-- 综合素质评价下查询 -->
  <div>
    <van-cell-group>
      <!-- 校区 -->
      <van-cell
        class="cell-border"
        title="校区："
        is-link
        size="large"
        @click="schoolPopupShow"
        value="请选择校区"
      >
        <div v-if="schoolSelected !== ''">{{schoolSelected}}</div>
      </van-cell>

      <!-- 学届 -->
      <van-cell
        class="cell-border"
        title="学届："
        is-link
        size="large"
        @click="studentYearPopupShow"
        value="请选择学届"
      >
        <div v-if="schoolYearSelected !== ''">{{schoolYearSelected}}</div>
      </van-cell>

      <!-- 学习阶段 -->
      <van-cell
        class="cell-border"
        title="学习阶段："
        is-link
        size="large"
        @click="studentGradePopupShow"
        value="请选择学习阶段"
      >
        <div v-if="studentGradeSelected !== ''">{{studentGradeSelected}}</div>
      </van-cell>

      <!-- 班级 -->
      <van-cell
        class="cell-border"
        title="班级："
        is-link
        required
        size="large"
        @click="studentOrganizePopupShow"
        value="请选择班级"
      >
        <div v-if="studentOrganizationSelected !== ''">{{studentOrganizationSelected}}</div>
      </van-cell>
    </van-cell-group>

    <!-- 选择校区弹出框 -->
    <van-popup v-model="schoolShow" position="bottom" round :style="{ height: '50%' }">
      <div>
        <div
          v-for="item in schoolNameList"
          :key="item.id"
          class="down-name van-hairline--bottom"
          @click="showNextYear(item)"
        >
          <div>{{ item.name }}</div>
        </div>
      </div>
    </van-popup>

    <!-- 选择学届弹出框 -->
    <van-popup v-model="studentYearsShow" position="bottom" round :style="{ height: '50%' }">
      <div>
        <div
          v-for="item in studentYearList"
          :key="item.id"
          class="down-name van-hairline--bottom"
          @click="showNextLevel(item)"
        >
          <div>{{ item.name }}</div>
        </div>
      </div>
    </van-popup>

    <!-- 选择学习阶段弹出框 -->
    <van-popup v-model="studentLevelShow" position="bottom" round :style="{ height: '50%' }">
      <div>
        <div
          v-for="item in studentGradeDataList"
          :key="item.id"
          class="down-name van-hairline--bottom"
          @click="showOrganization(item)"
        >
          <div>{{ item.name }}</div>
        </div>
      </div>
    </van-popup>

    <!-- 选择班级弹出框 -->
    <van-popup v-model="studentOrganizeShow" position="bottom" round :style="{ height: '50%' }">
      <div>
        <div
          v-for="item in studentOrganizationDataList"
          :key="item.id"
          class="down-name van-hairline--bottom"
          @click="selectOrganization(item)"
        >
          <div>{{ item.name }}</div>
        </div>
      </div>
    </van-popup>

    <!-- <van-button
                    v-bind:loading="loading"
                    size="large"
                    loading-txt="查询中.."
                    bgcolor="#4899fb"
                    color="#fff"
                    @click.native="search"
    >查询</van-button>-->

    <van-button @click.native="search" class="button-position" type="primary" size="large">查询</van-button>
  </div>
</template>

<script>
import xyapi from "@/common/api";
import xyUtils from "@/common/utils";
export default {
  name: "SearchParameter",
  components: {},
  data() {
    return {
      activeTab: 0,
      popShow: true,
      apiPath: "${this.xyMApi}/api/AchievementAnalysis",
      loading: false, //保存中状态

      schoolShow: false,
      studentYearsShow: false,
      studentLevelShow: false,
      studentOrganizeShow: false,

      // 校区
      schoolNameList: [],
      schoolSelected: "",
      schoolId: "",

      // 学届
      studentYearList: [],
      schoolYearSelected: "",
      studentYearId: "",

      // 学习阶段
      studentGradeDataList: [],
      studentGradeSelected: "",
      studentGradeId: "",

      // 班级
      studentOrganizationDataList: [],
      studentOrganizationSelected: "",
      studentOrganizationId: "",

      // 我的评分
      studentInfo: {},

      pageList: []
    };
  },

  created: function() {
    this.getSchools();
  },
  mounted: function() {},
  methods: {
    schoolPopupShow: function() {
      this.schoolShow = true;
    },
    studentYearPopupShow: function() {
      this.studentYearsShow = true;
    },
    studentGradePopupShow: function() {
      this.studentLevelShow = true;
    },
    studentOrganizePopupShow: function() {
      this.studentOrganizeShow = true;
    },

    async getSchools() {
      var _this = this;
      let res = await xyapi.get(
        this.xyMApi + "/xy/comm/SchoolDistrictList"
        // null
      );
      if (!res.success) {
        xyUtils.msgError(res.data.msg);
      } else {
        if (res.data.length > 0) {
          _this.schoolNameList = [];
          res.data.forEach(function(item) {
            _this.schoolNameList.push({
              name: item.SchoolDistrictName,
              id: item.SchoolDistrictID
              // callback: function(e) {
              //   _this.schoolData.Name = e.label
              //   _this.schoolData.ID = e.id
              //   //选择校区时
              //   _this.studentYearData.ID = ""
              //   _this.studentYearData.Name = ""
              //   _this.studentGradeData.ID = ""
              //   _this.studentGradeData.Name = ""
              //   _this.getstudentYears(e.id)
              // }
            });

            // res.data.map(function(item){
            //   _this.schoolNameList.push({
            //     id: item.SchoolDistrictID,
            //     name: item.SchoolDistrictName
            //   })
            //   return _this.schoolNameList

            // _this.schoolData.List.push({
            //   id: item.SchoolDistrictID,
            //   name: item.SchoolDistrictName,
            //   callback: function(e) {
            //     _this.schoolData.Name = e.label
            //     _this.schoolData.ID = e.id
            //     //选择校区时
            //     _this.studentYearData.ID = ""
            //     _this.studentYearData.Name = ""
            //     _this.studentGradeData.ID = ""
            //     _this.studentGradeData.Name = ""
            //     _this.getstudentYears(e.id)
            //   }
            // })
          });
        }
      }
    },

    showNextYear: function(item) {
      this.schoolId = item.id;
      this.getstudentYears(item.id);
      this.schoolSelected = item.name;
      this.schoolShow = false;
    },

    async getstudentYears() {
      var _this = this;
      let res = await xyapi.get(
        this.xyMApi + "/xy/comm/StudentYearList",
        {
          schoolID: _this.schoolId
        }
      );
      if (!res.success) {
        xyUtils.msgError(res.data.msg);
      } else {
        if (res.data.length > 0) {
          _this.studentYearList = [];
          res.data.forEach(function(item) {
            // _this.studentYearData.List.push({
            //   id: item.StudentYearID,
            //   label: item.StudentYearName,
            //   callback: function(e) {
            //     _this.studentYearData.Name = e.label
            //     _this.studentYearData.ID = e.id
            //     _this.studentGradeData.ID = ""
            //     _this.studentGradeData.Name = ""
            //     _this.getstudentGrades(schoolId, e.id)
            // }
            // })
            _this.studentYearList.push({
              id: item.StudentYearID,
              name: item.StudentYearName
            });
          });
        }
      }
    },

    showNextLevel: function(item) {
      this.studentYearId = item.id;
      this.schoolYearSelected = item.name;
      this.studentYearsShow = false;
      this.getstudentGrades();
    },

    async getstudentGrades() {
      var _this = this;
      let res = await xyapi.get(
        this.xyMApi + "/xy/comm/StudentGradeList",
        {
          schoolID: _this.schoolId,
          studentYearID: _this.studentYearId
        }
      );
      if (!res.success) {
        xyUtils.msgError(res.data.msg);
      } else {
        _this.studentGradeDataList = [];
        if (res.data.length > 0) {
          res.data.forEach(function(item) {
            // _this.studentGradeData.List.push({
            //   id: item.StudentGradeID,
            //   label: item.StudentGradeName,
            //   callback: function(e) {
            //     _this.studentGradeData.Name = e.label
            //     _this.studentGradeData.ID = e.id
            //     _this.getStudentOrganization()
            //   }
            // })
            _this.studentGradeDataList.push({
              id: item.StudentGradeID,
              name: item.StudentGradeName
            });
          });
        }
      }
    },

    showOrganization: function(item) {
      this.studentLevelShow = false;
      this.studentGradeId = item.id;
      this.studentGradeSelected = item.name;
      this.getStudentOrganization();
    },

    async getStudentOrganization() {
      var _this = this;
      let res = await xyapi.get(
        this.xyMApi +
          "/api/StudentOrganization/GetStudentOrganization",
        {
          schoolID: _this.schoolId || 0, //校区
          studentYearID: _this.studentYearId || 0, //学届
          studentGradeID: _this.studentGradeId || 0 //学习阶段
        }
      );
      if (!res.success) {
        xyUtils.msgError(res.data.msg);
      } else {
        _this.studentOrganizationDataList = [];
        if (res.data.length > 0) {
          res.data.forEach(function(item) {
            _this.studentOrganizationDataList.push({
              id: item.StudentOrganizationID,
              name: item.StudentOrganizationName
            });
          });
        }
      }
    },

    selectOrganization: function(item) {
      this.studentOrganizeShow = false;
      this.studentOrganizationId = item.id;
      this.studentOrganizationSelected = item.name;
    },

    //查询
    search: function() {
      if (this.studentOrganizationId < 1) {
        xyUtils.msgError("请选择班级");
        return false;
      }
      this.$store.commit("evaluation/getOrganizationId", {
        studentOrganizationId: this.studentOrganizationId
      });
      this.$router.push("/home/synthesizeQuality/searchList");
    }
  }
};
</script>

<style lang="less" scoped>
.van-icon-arrow-down:before {
  content: "\F00A";
}

.no-border {
  border: 0;
  width: auto;
  height: auto;
  display: block;
  font-size: 22px;
  margin-right: 0;
}

.slot-position {
  margin-left: 0;
}

.cell-border {
  border-top: 10px solid #f9f9f9;
}

.button-position {
  margin-top: 10px;
}

.down-name {
  text-align: center;
  height: 100px;
  line-height: 100px;
  // .1px();
}
</style>